import { Logo } from './Logo';

const SHOP_LINKS = ['Phones', 'Laptops', 'Audio', 'Accessories', 'TVs', 'Gaming'];

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-bg2 px-4 pb-8 pt-12 sm:px-8">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 sm:grid-cols-2 md:grid-cols-4">
        <div>
          <Logo className="mb-3 text-lg" />
          <p className="text-sm leading-relaxed text-text-muted">
            Uganda&apos;s fast gadget shop. Genuine phones, laptops, audio and accessories —
            straight to your door.
          </p>
        </div>

        <FooterColumn title="Shop">
          {SHOP_LINKS.map((label) => (
            <a key={label} href="#shop" className="text-sm text-text-muted hover:text-accent">
              {label}
            </a>
          ))}
        </FooterColumn>

        <FooterColumn title="Chikwafu">
          <a href="#how" className="text-sm text-text-muted hover:text-accent">
            How it works
          </a>
          <a href="#contact" className="text-sm text-text-muted hover:text-accent">
            Contact
          </a>
        </FooterColumn>

        <FooterColumn title="Contact">
          <a
            href="https://wa.me/256780844098"
            className="text-sm text-text-muted hover:text-accent"
          >
            WhatsApp: 0780 844 098
          </a>
          <a href="tel:+256780844098" className="text-sm text-text-muted hover:text-accent">
            Call: 0780 844 098
          </a>
          <span className="text-sm text-text-muted">Kampala, Uganda</span>
        </FooterColumn>
      </div>

      <div className="mx-auto mt-8 flex max-w-6xl flex-col items-center justify-between gap-2 border-t border-white/10 pt-6 text-center sm:flex-row sm:text-left">
        <p className="text-xs text-text-dim">
          © 2026 Chikwafu. All rights reserved. Prices in UGX · Delivery arranged via WhatsApp
        </p>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }) {
  return (
    <div>
      <h4 className="mb-4 text-xs font-extrabold uppercase tracking-wider text-text-muted">
        {title}
      </h4>
      <ul className="flex flex-col gap-2">{children}</ul>
    </div>
  );
}
